import { gql } from 'apollo-angular';

export const ConfirmPasswordResetDocument = gql(/* GraphQL */ `
  mutation confirmPasswordReset($password: String!, $token: String!) {
    confirmPasswordReset(password: $password, token: $token)
  }
`);
